import { endPoints } from "../../../Config";
import { handleGetRequest } from "../../../service/GetTemplate";
import { handlePostRequest } from "../../../service/PostTemplate";
import { handlePatchRequest } from "../../../service/PatchTemplate";

export const getDemonstrations = (params, dispatch) =>
  handleGetRequest(
    endPoints.getMachineDemonstrations(params),
    false,
    false,
    dispatch
  );

export const getDemonstration = (id, dispatch) =>
  handleGetRequest(
    endPoints.getMachineDemonstration(id),
    false,
    false,
    dispatch
  );

export const createDemonstration = (payload, dispatch) =>
  handlePostRequest(
    payload,
    endPoints.createMachineDemonstration,
    false,
    false
  )(dispatch);

export const updateDemonstration = (id, payload, dispatch) =>
  handlePatchRequest(
    payload,
    endPoints.updateMachineDemonstration(id),
    false,
    false
  )(dispatch);

export const performDemonstrationAction = (id, payload, dispatch) =>
  handlePostRequest(
    payload,
    endPoints.performMachineDemonstrationAction(id),
    false,
    false
  )(dispatch);
